import FormHelperText from '@mui/material/FormHelperText'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import { LoaderData, ParticipantStatus, OptionPathKeys, OptionType } from '../../../../types'
import type { eventRegistrationDetailsLoader } from '../RegisterEvents.loader'
import { RegistrationOptions } from './filterRegistrationOptions'

interface Props {
  path: OptionPathKeys
  elem: RegistrationOptions
  setOptionsByType: (path: OptionPathKeys, value: string, elem: RegistrationOptions) => void
  registrationDetails: LoaderData<ReturnType<typeof eventRegistrationDetailsLoader>>
}

export default function InformationLine({
  elem,
  setOptionsByType,
  registrationDetails,
  path,
}: Props) {
  const { t } = useTranslation()

  const label = <strong>{elem.option.name}</strong>
  const price = Number(elem.price) ? `${elem.price}€` : t('Inclus')
  const disabled =
    !elem.available ||
    registrationDetails?.existing_registration?.status === ParticipantStatus.Confirmed

  return (
    <Stack>
      <Stack>
        <Typography className="MuiFormControlLabel-label">{label}</Typography>
        {!disabled && elem.option.registration_information && (
          <FormHelperText sx={{ fontWeight: 600, fontSize: '0.9rem' }}>
            {elem.option.registration_information}
          </FormHelperText>
        )}
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        margin={!disabled && elem.option.registration_information ? '0.5rem 0' : undefined}
      >
        <TextField
          key={elem.option.id}
          variant="filled"
          onChange={event => {
            setOptionsByType(path, String(event.target.value), elem)
          }}
          defaultValue={elem.registered?.value ?? ''}
          disabled={disabled}
          fullWidth
          multiline={elem.option.type === OptionType.TextOption}
          type={elem.option.type === OptionType.NumberOption ? 'number' : 'text'}
          rows={elem.option.type === OptionType.TextOption ? 1 : undefined}
          sx={{ flex: '1 0' }}
        />
        <Stack flex={{ sm: '0.5 0', lg: '0.8 0' }}>
          {Number(elem.price) ? (
            <Typography className="MuiFormControlLabel-label" fontWeight="bold">
              {price}
            </Typography>
          ) : null}
        </Stack>
      </Stack>
    </Stack>
  )
}
